import schema from 'govbr.frontend.policy/components/Blocks/Video/schema';

export default schema;
